import React, {Component, Fragment} from "react";
import Form from "../../../Leads/Form";
import {
    getOrganizationInfo,
    showToast,
    updateOrganizationInfo
} from "../../../../Common/Appcommon";

export default class Organization extends Component {
    constructor(props) {
        super(props);

        this.state = {
            formname : process.env.REACT_APP_ORGANIZATION_FORMNAME,
            organizationId : getOrganizationInfo('organizationid')
        };
    }

    onsave = (formData) => {

        let refreshPage = false;
        //update organization details in session to reflect the changes instantly.
        if(formData['Display_Name'] !== undefined){
            updateOrganizationInfo(formData['Display_Name'],'appTitle');
            refreshPage = true;
        }

        if(formData['Logo'] !== undefined){
            updateOrganizationInfo(formData['Logo'],'logo');
            refreshPage = true;
        }

        const successMsg = "Organization updated successfully.";

        showToast(successMsg,"top-right","success",function () {
            if(refreshPage){
                window.location.href = "#/settings/account/organization";
                window.location.reload();
            }
        },1000);
    }

    render() {

        const {formname, organizationId} = this.state;
        const title = "Update Organization";

        return (
            <Fragment>
                <Form
                    formname={formname}
                    formid={organizationId}
                    settingsForm={true}
                    title={title}
                    onsave={this.onsave}
                />
            </Fragment>
        );
    }
}